import React from 'react';
import { useTranslation } from 'react-i18next';

type Stage = { contractNumber: number; milestoneNumber: number; amountOre: number };
export interface FundingNoticeData {
  projectName?: string;
  recipientRole?: 'person' | 'company';
  amountOre: number;
  availableBalanceOre: number;
  requiredAmountOre: number;
  stages: Stage[];
  startedMilestone?: Stage;
}

/** The same historical financial snapshot as the notice's email. */
export function FundingNoticeContent({ data, eventKey }: { data: FundingNoticeData; eventKey: string }) {
  const { t, i18n } = useTranslation();
  const key = 'fundingNotice.projectAccount';
  const fulfilled = eventKey === 'payment.funding_fulfilled';
  const money = (ore: number) => new Intl.NumberFormat(i18n.language, { style: 'currency', currency: 'SEK' }).format(ore / 100);
  const stageLabel = (stage: Stage) => t(`${key}.stageLabel`, { contract: stage.contractNumber, milestone: stage.milestoneNumber, amount: money(stage.amountOre) });
  const bodyKey = fulfilled ? data.recipientRole === 'company' ? 'fulfilledCompanyBody' : 'fulfilledPersonBody' : eventKey === 'payment.unfunded_start' ? 'startBody' : eventKey === 'payment.funding_reminder' ? 'accountReminderBody' : 'accountRequiredBody';
  return <div className="objection-money d-block text-explain" data-testid="funding-notice-content">
    <p>{t(`${key}.${bodyKey}`, { projectDescription: data.projectName, amount: money(data.amountOre) })}</p>
    {data.startedMilestone && <p className="fw-semibold">{t(`${key}.startedStage`, { stage: stageLabel(data.startedMilestone) })}</p>}
    <p className="fw-semibold mb-1">{t(`${key}.stagesLabel`)}</p>
    <ul>{data.stages.map(stage => <li key={`${stage.contractNumber}-${stage.milestoneNumber}`}>{stageLabel(stage)}</li>)}</ul>
    <dl className="row">
      <dt className="col-12 col-sm-7">{t(`${key}.balanceLabel`)}</dt><dd className="col-12 col-sm-5 text-sm-end text-nowrap">{money(data.availableBalanceOre)}</dd>
      <dt className="col-12 col-sm-7">{t(`${key}.requiredLabel`)}</dt><dd className="col-12 col-sm-5 text-sm-end text-nowrap">{money(data.requiredAmountOre)}</dd>
      <dt className="col-12 col-sm-7">{t(`${key}.missingLabel`)}</dt><dd className="col-12 col-sm-5 text-sm-end text-nowrap fw-bold">{money(data.amountOre)}</dd>
    </dl>
    <p>{t(`${key}.planning`)}</p>
    <p className="mb-0">{t(`${key}.${fulfilled ? 'remindersStopped' : 'optionalRemainder'}`)}</p>
  </div>;
}
